var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fuel-funds__sidebar h-mobile-margin-top-24h-mobile-no-border-radius"
    },
    [
      _c(
        "div",
        { staticClass: "fuel-funds__total-tag h-mobile-no-border-radius" },
        [
          _c("h3", { staticClass: "h-big-dollar-sign" }, [_vm._v("$")]),
          _vm._v(" "),
          _c("h1", { staticClass: "fuel-funds__total" }, [
            _vm._v(_vm._s(_vm.totalAvailable))
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "fuel-funds__terms h-center-align" }, [
        _c("p", { staticClass: "h-italic-text h-helper-text h-center-align" }, [
          _vm._v(
            "\n      Deposits for Digital Promo funds will show up by the 15th of the following month. For example, if you qualified for the promo in January, you will see the deposit by February 15.\n    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "h-italic-text h-helper-text" }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.activateModal($event)
                }
              }
            },
            [_vm._v("(Terms and Conditions)")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "h-mobile-medium-hidden" })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fuel-funds__available" }, [
      _c("h2", { staticClass: "fuel-funds__available--text" }, [
        _vm._v("Available")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }